import axios from 'axios'

// Documents are no longer public S3 URLs. They are streamed through the
// authenticated API (the global axios request interceptor attaches the bearer
// token) and opened as a blob. Use { admin: true } from staff/admin views,
// which are allowed to open any document; the default route only serves
// documents the current user owns.
export const openStoredDocument = async (
  documentId: number,
  { admin = false }: { admin?: boolean } = {},
): Promise<void> => {
  const path = admin
    ? `/admin/documents/${documentId}/file`
    : `/me/documents/${documentId}/file`

  const response = await axios.get(process.env.NEXT_PUBLIC_API_URL + path, {
    responseType: 'blob',
  })

  const blobUrl = URL.createObjectURL(response.data)
  window.open(blobUrl, '_blank', 'noopener,noreferrer')
  // Revoke after the new tab has had time to load the blob.
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000)
}
